import { HttpClient } from '@angular/common/http';
import { NDDGridService } from '@ndk/ng-grid';
import { LocalStorageService } from '@ndk/ng-storage';
import { State } from '@progress/kendo-data-query';

import { LocalStorageKeys } from '@core/storage/local-storage.enum';

/**
 * Classe abstrata do serviço do grid, com inclusão do idioma atual na chamada odata.
 * @extends NDDGridService
*/
export abstract class NDDGridWithCurrentLanguageService extends NDDGridService {
    private localStorage: LocalStorageService;

    constructor(http: HttpClient, url: string, localStorage: LocalStorageService) {
        url += `?language=${ localStorage.getValue(LocalStorageKeys.CurrentLanguage) }`;
        super(http, url);
        this.localStorage = localStorage;
    }

    /**
     * Ao trocar o idioma do Portal, é apenas recriado o HTML, então não recriará o serviço do grid, o que fará que mantenha a linguagem antiga na URL
     * O ajuste é para sempre setar o idioma atual ao atualizar o grid
    */
    public query(state: State): void {
        if (this.url.includes('?language=')) {
            // tslint:disable-next-line:no-magic-numbers
            const currentLang: string = this.url.split('?language=')[1]?.substring(0, 5);
            this.url = this.url.replace(currentLang, this.localStorage.getValue(LocalStorageKeys.CurrentLanguage));
        }

        super.query(state);
    }
}
